import { FC, PropsWithChildren } from 'react';

import { Icon } from '@atom/mui';
import { downloadFile, sanitizeFilename } from '@atom/utilities/fileUtilities';

import { useChatContext } from './ChatContext';
import ChatPrimaryButton from './ChatPrimaryButton';

import classes from './chat.module.css';

export type ChatMarkdownTableProps = {
  csv?: string;
};

const ChatMarkdownTable: FC<PropsWithChildren<ChatMarkdownTableProps>> = ({
  children,
  csv,
}) => {
  const { threadsData } = useChatContext();

  const handleExport = () => {
    const title = threadsData.currentThread?.title;
    const date = new Date().toISOString().slice(0, 10);
    const fileName = sanitizeFilename(title ?? 'Chat');
    const blob = new Blob([csv ?? ''], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    downloadFile(url, `${fileName} ${date}.csv`);
  };

  return (
    <>
      <table className={classes.markdownTable}>{children}</table>
      <ChatPrimaryButton
        startIcon={<Icon>file_download</Icon>}
        onClick={handleExport}
      >
        Export to CSV
      </ChatPrimaryButton>
    </>
  );
};

export default ChatMarkdownTable;
